import * as React from 'react';
import { useContext } from 'react';

import { BufferBagsContext } from '.';
import { Dropdown } from '../Dropdown';
import { Button } from '../buttons/Button';

export const BufferBagsStep1 = () => {
  const { petOptions, setSelectedDog, navigateBetweenSteps, selectedDog } =
    useContext(BufferBagsContext);

  return (
    <div className="flex flex-col gap-4">
      <div className="w-full pr-2 pt-3 flex flex-col gap-2">
        <div className="text-md font-semibold text-left">
          <h3>Which dog would you like to add extra meals for?</h3>
        </div>
        <div className="mb-2 max-w-[80%]">
          <Dropdown
            options={petOptions}
            selectedOption={selectedDog || { value: '', label: 'Select dog' }}
            setSelectedOption={setSelectedDog}
          />
        </div>
      </div>
      <div className="mt-[45px] w-fill flex justify-center">
        <Button
          isDisabled={selectedDog === undefined}
          label="Continue"
          variant={selectedDog ? 'primary' : 'secondary'}
          onClick={navigateBetweenSteps}
        />
      </div>
    </div>
  );
};
